module.exports = __webpack_public_path__ + "static/tpp-image02-86afe264b91366f10e5ef0078041b8ae.png";